window._define('widgets/classname-switcher', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) { 'use strict';
    $.widget('OC.classnameSwitcher', BaseWidget, {

        options: {
            aliases: {
                close: 'add',
                open: 'remove',
            },
            eventname: 'click',
            target: '', // css selector, elements that will have the classname toggled, if empty 'this.element' will be used
            classnameToToggle: '', // classname to toggle
        },

        _getTarget: function () {
            var targetOption = this.options.target,
                element;

            if (!this.elements.$target) {
                if (this.options.target) {
                    // jquery element
                    if (targetOption instanceof $ || targetOption instanceof HTMLElement) {
                        element = targetOption;
                    } else {
                        if (targetOption.charAt(0) === '#' || targetOption.charAt(0) === '.') {
                            element = $(targetOption);
                        } else if (targetOption === 'parent') {
                            element = this.element.parent();
                        } else {
                            element = this.element.closest(targetOption);
                        }
                    }
                }

                if (!element || element.length === 0) {
                    element = this.element;
                }

                this.elements.$target = $(element);
            }

            return this.elements.$target;
        },

        _create: function () {
            var self = this,
                options = this.options;

            this._super();

            // suppress 300ms delay on some touch device/browser
            if (options.eventname === 'click' && 'ontouchstart' in window) {
                this.options.eventname = 'tap';
            }

            this.element.on(options.eventname + '.oc.classnameswitcher', function (event) {
                event.preventDefault();
                self.toggle();
            });

            this.savedClassnames = this._getTarget().attr('class');

            // using add && remove methods is not always very intuitive
            // we provide aliases for those methods (default close->add, open->remove)
            // and we can pass in aliases via options
            Object.keys(options.aliases).forEach(function (alias) {
                var bindTo = self[options.aliases[alias]];

                if (bindTo && !self[alias]) {
                    self[alias] = bindTo;
                }
            });
        },

        toggle: function (state, noevent) {
            this._toggle(state, noevent);
            return this;
        },

        add: function (noevent) {
            this._toggle(true, noevent);
            return this;
        },

        remove: function (noevent) {
            this._toggle(false, noevent);
            return this;
        },

        destroy: function () {
            this._super();
            this.element.off(this.options.eventname + '.oc.classnameswitcher');
            this._getTarget().attr('class', this.savedClassnames);
        },

        _toggle: function (state, noevent) {
            var $target = this._getTarget(),
                classname = this.options.classnameToToggle;

            if (typeof state !== 'boolean') {
                state = !$target.hasClass(classname);
            }

            $target.toggleClass(classname, state);

            if (!noevent) {
                this._trigger('onSwitch', null, {
                    'classname': classname,
                    'event': state ? 'add' : 'remove',
                });
            }
        },
    });

    $(function (){
        $('.js-classname-switcher').classnameSwitcher();
    });

    return $.OC.classnameSwitcher;

});
